import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MissionisLive = (props) => {
    const routerNavigate = useNavigate();
    const navigate = props.navigate || routerNavigate;
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const formatDateTime = (date) => {
        const d = date.getDate().toString().padStart(2, '0');
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const y = date.getFullYear();
        const h = date.getHours().toString().padStart(2, '0');
        const min = date.getMinutes().toString().padStart(2, '0');
        const s = date.getSeconds().toString().padStart(2, '0');
        return `${d}/${m}/${y}, ${h}:${min}:${s}`;
    };

    const handleMissionSubmit = async () => {
        if (props.onStopMission) {
            props.onStopMission();
        }
    }

    return (
        <div className="min-h-[100dvh] bg-white flex flex-col font-sans relative">
            <div className="flex flex-col flex-1 px-8 pt-16 pb-32 max-w-md mx-auto w-full text-center">

                <h1 className="text-2xl font-bold text-gray-900 mb-2 uppercase tracking-tight">
                    Mission is <span className="text-red-600">Live</span>
                </h1>

                <p className="text-gray-400 font-bold text-xs uppercase tracking-widest mb-12">
                    {formatDateTime(currentTime)}
                </p>

                <div className="mt-auto pb-12">
                    <button
                        onClick={handleMissionSubmit}
                        className="w-full bg-[#B22222] hover:bg-red-800 text-white font-medium py-3.5 px-6 rounded-xl shadow-sm transition transform active:scale-95 text-base">
                        Stop Mission
                    </button>
                </div>
            </div>

            {/* Bottom Nav matching Home */}
            <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-[0_-5px_15px_rgba(0,0,0,0.02)] z-50">
                <div className="flex items-center justify-center gap-x-20 py-4 max-w-md mx-auto">
                    <button onClick={() => navigate('/collectors-home')} className="flex flex-col items-center space-y-1 text-[#00BFA5]">
                        <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                        </svg>
                        <span className="text-[11px] font-medium">Home</span>
                    </button>
                    <button onClick={() => navigate('/logs')} className="flex flex-col items-center space-y-1 text-gray-400">
                        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-[11px] font-medium">Logs</span>
                    </button>
                </div>
            </nav>
        </div>
    );
};

export default MissionisLive;